import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  templates: Array<any>;
  pickedInterbankTemplate: any;
  permissions: any;
  paymentsPermissions: any;
  pickedInternalTemplate: any;
  pickedSwiftTemplate: any;
  pickedSwiftRubTemplate: any;
  pickedSwiftTjsTemplate: any;
  notifications: any;
}
const initialState: UserState = {
  templates: [],
  pickedInterbankTemplate: {},
  permissions: [],
  paymentsPermissions: [],
  pickedInternalTemplate: {},
  pickedSwiftTemplate: {},
  pickedSwiftRubTemplate: {},
  pickedSwiftTjsTemplate: {},
  notifications: [],
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    notificationsAC(state, action: PayloadAction<any>) {
      state.notifications = action.payload;
    },
    markNotificationsReadAC(state, action: PayloadAction<number[]>) {
      const markRead = (items: any[]) =>
        items.map((item: any) => (action.payload.includes(item.id) ? { ...item, is_read: true } : item));

      if (Array.isArray(state.notifications)) {
        state.notifications = markRead(state.notifications);
      } else if (state.notifications?.results) {
        state.notifications.results = markRead(state.notifications.results);
      }
    },
    pickedSwiftTjsTemplateAC(state, action: PayloadAction<any>) {
      state.pickedSwiftTjsTemplate = action.payload;
    },
    pickedSwiftRubTemplateAC(state, action: PayloadAction<any>) {
      state.pickedSwiftRubTemplate = action.payload;
    },
    pickedSwiftTemplateAC(state, action: PayloadAction<any>) {
      state.pickedSwiftTemplate = action.payload;
    },
    permissionsAC(state, action: PayloadAction<any>) {
      state.permissions = action.payload;
      if (action.payload?.payments?.length > 0) {
        state.paymentsPermissions = action.payload.payments;
      }
    },

    pickedInterbankTemplateAC(state, action) {
      state.pickedInterbankTemplate = action.payload;
    },
    pickedInternalTemplateAC(state, action) {
      state.pickedInternalTemplate = action.payload;
    },
    templatesAC(state, action) {
      state.templates = [];
      action.payload.forEach((item: any) => {
        state.templates.push({
          ...item,
          label: item.title,
          value: item.id,
        });
      });
    },
  },
});

export const {
  templatesAC,
  pickedInterbankTemplateAC,
  permissionsAC,
  pickedInternalTemplateAC,
  pickedSwiftTemplateAC,
  pickedSwiftRubTemplateAC,
  pickedSwiftTjsTemplateAC,
  notificationsAC,
  markNotificationsReadAC,
} = user.actions;
export default user.reducer;
